import React from "react";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Chip,
  Stack,
  Typography,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { OutlinedInput } from "@mui/material";

const popularityLevels = [0, 1, 2, 3, 4, 5];
const categoryOptions = [
  { value: "specialtyCake", label: "Specialty Cake" },
  { value: "standardCake", label: "Standard Cake" },
];

const FlavorGeneralInfoSection = ({ formData, setFormData, icings }) => {
  const handleCategoryChange = (event) => {
    const { value } = event.target;
    setFormData({
      ...formData,
      category: typeof value === "string" ? value.split(",") : value,
    });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
      <TextField
        margin="dense"
        name="name"
        label="Flavor Name"
        fullWidth
        value={formData.name}
        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        required
      />

      <TextField
        margin="dense"
        name="displayName"
        label="Display Name"
        fullWidth
        value={formData.displayName}
        onChange={(e) =>
          setFormData({ ...formData, displayName: e.target.value })
        }
        required
      />

      <TextField
        margin="dense"
        name="description"
        label="Description"
        fullWidth
        multiline
        rows={3}
        value={formData.description}
        onChange={(e) =>
          setFormData({ ...formData, description: e.target.value })
        }
        required
      />

      <FormControl fullWidth margin="dense">
        <InputLabel>Icing</InputLabel>
        <Select
          value={formData.icing?.name || ""}
          onChange={(e) => {
            const selected = icings.find((i) => i.name === e.target.value);
            setFormData({ ...formData, icing: selected || null });
          }}>
          {icings.map((icing) => (
            <MenuItem key={icing._id} value={icing.name}>
              {icing.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        margin="dense"
        name="price"
        label="Price"
        type="number"
        fullWidth
        value={formData.price}
        onChange={(e) => setFormData({ ...formData, price: e.target.value })}
        required
      />

      <FormControlLabel
        control={
          <Switch
            checked={formData.basePriceIncluded}
            onChange={(e) =>
              setFormData({ ...formData, basePriceIncluded: e.target.checked })
            }
            color="primary"
          />
        }
        label="Included in Base Price"
      />

      <FormControlLabel
        control={
          <Switch
            checked={formData.isPremium || false}
            onChange={(e) =>
              setFormData({ ...formData, isPremium: e.target.checked })
            }
            color="primary"
          />
        }
        label="Premium Flavor"
      />

      <FormControl
        fullWidth
        margin="dense"
        error={!formData.category || formData.category.length === 0}>
        <InputLabel>Category</InputLabel>
        <Select
          multiple
          value={formData.category || []}
          onChange={handleCategoryChange}
          input={<OutlinedInput label="Category" />}
          renderValue={(selected) =>
            selected
              .map(
                (val) =>
                  categoryOptions.find((o) => o.value === val)?.label || val
              )
              .join(", ")
          }>
          {categoryOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              <Chip label={option.label} size="small" />
            </MenuItem>
          ))}
        </Select>
        {(!formData.category || formData.category.length === 0) && (
          <Typography variant="caption" color="error">
            Please select at least one category
          </Typography>
        )}
      </FormControl>

      <Box sx={{ my: 2 }}>
        <Typography variant="subtitle1" sx={{ mb: 0.5 }}>
          Popularity Level
        </Typography>

        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ minWidth: 80 }}>
            🔥 Most Popular
          </Typography>

          <Stack direction="row" spacing={1}>
            {popularityLevels.map((level) => (
              <Chip
                key={level}
                label={level}
                clickable
                variant={formData.popularity === level ? "filled" : "outlined"}
                color={formData.popularity === level ? "primary" : "default"}
                onClick={() => setFormData({ ...formData, popularity: level })}
              />
            ))}
          </Stack>

          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ minWidth: 80 }}>
            📉 Least Popular
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default FlavorGeneralInfoSection;
